/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// mantine
import { rem } from '@mantine/core';
import { notifications } from '@mantine/notifications';

// i18n
import i18n from 'i18next';

// icons
import { IconCheck, IconX } from '@tabler/icons-react';

// api
import { apiClient } from '@lib/api-client';

// types
import { TCertificate } from '@global-types/index';

// enums
import { QueueStatus } from '@config/constants/enum';
import isNil from 'lodash/isNil';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

const sendCertificateService = (data: {
	certificateId: string;
	email?: string;
}): Promise<TCertificate> => {
	return apiClient.post(
		`/certificates/send/${data.certificateId}`,
		{
			...(!isNil(data.email)
				? { email: data.email }
				: {}),
		}
	);
};

export const sendCertificate = async (data: {
	idNotification: string;
	certificateId: string;
	email?: string;
}) => {
	try {
		const fetchCertificate = async (id: string) => {
			let response: TCertificate;

			const getStatus = (response: TCertificate) => {
				return response?.status || '';
			};

			const getCertificate = async () => {
				response = await apiClient.get(
					`/certificates/${id}`,
					{
						params: {
							populate: ['media'],
						},
					}
				);

				const status = getStatus(response);

				if (status !== QueueStatus.SUCCESS) {
					setTimeout(async () => {
						await getCertificate();
					}, 2000);
				} else {
					// Send certificate
					sendCertificateService({
						certificateId: data.certificateId,
						email: data.email,
					}).then((response) => {
						notifications.update({
							id: data.idNotification,
							loading: false,
							title: i18n.t('global.success'),
							message: i18n.t(
								`notifications.certificateSuccessfullySended`
							),
							color: 'var(--mantine-color-igluGreen-9)',
							icon: (
								<IconCheck
									style={{
										width: rem(18),
										height: rem(18),
									}}
								/>
							),
							autoClose: 7000,
						});
					});
				}
			};

			await getCertificate();
		};

		fetchCertificate(data.certificateId);
	} catch (error) {
		console.error('error certificate[api] :', error);
		notifications.update({
			id: data.idNotification,
			loading: false,
			color: 'var(--mantine-color-igluRed-9)',
			title: i18n.t(`global.error`),
			message: i18n.t(`api.NOT_FOUND`),
			autoClose: 7000,
			icon: (
				<IconX
					style={{ width: rem(18), height: rem(18) }}
				/>
			),
		});
	}
};
